import { Platform, StyleSheet, Text, type TextStyle } from 'react-native';
import { theme } from '@/constants/theme';

export default function TrueFocus({ text, style }: { text: string; style?: TextStyle }) {
  return <Text style={[s.text, style]}>{text}</Text>;
}

const s = StyleSheet.create({
  text: {
    color: '#fff',
    fontFamily: theme.fonts.bold,
    fontSize: 40,
    lineHeight: 50,
    textAlign: 'center',
    textShadowColor: '#7C3AED88',
    textShadowRadius: 18,
    ...(Platform.OS === 'web' ? ({ backgroundImage: 'linear-gradient(90deg,#7a00ff,#00e0ff)', WebkitBackgroundClip: 'text', color: 'transparent' } as any) : {}),
  },
});
